import {
  academicGroupMembersBreadcrumbs,
  academicGroupMembersRoutesObj,
} from "./path";

import { concatRoutesMetadata, createRoute } from "@/routes/utils";
import type { IPartialRouteMetadataObj } from "@/routes/types";
import { facultyMemberRouteMetadata } from "@routes/admin/usersManagement/facultyMembers/route";

const partialAcademicGroupMembersRoutesMetadata: IPartialRouteMetadataObj<
  typeof academicGroupMembersRoutesObj
> = {
  list: {
    title: "facultyMembersList",
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/academicGroupMembers/table/page"
      ),
    mode: "index",
  },
  create: {
    title: "addFacultyMember",
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/academicGroupMembers/form/page"
      ),
    mode: "create",
  },
  edit: {
    title: "editFacultyMemberOf",
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/academicGroupMembers/form/page"
      ),
    mode: "edit",
  },
  view: {
    title: "viewFacultyMemberOf",
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/academicGroupMembers/form/page"
      ),
    mode: "view",
  },
};

const academicGroupMembersRoutesMetadata = concatRoutesMetadata<
  typeof academicGroupMembersRoutesObj
>(facultyMemberRouteMetadata, partialAcademicGroupMembersRoutesMetadata);

export const academicGroupMembersRoutes = createRoute<
  typeof academicGroupMembersRoutesObj
>(
  academicGroupMembersRoutesObj,
  academicGroupMembersRoutesMetadata,
  academicGroupMembersBreadcrumbs,
);
